import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@store/store-helper";
import { slideNodesAdapter } from "@store/slide-nodes/slide-nodes-slice";
import { ArSlideJson } from "@custom-types/core-api-legacy-types";

/**
 * Get the store slide nodes
 */
export const slideNodesSelector: (state: RootState) => ArSlideJson[] =
  createSelector(
    (state: RootState) => state,
    (state: RootState) => {
      return slideNodesAdapter.getSelectors().selectAll(state.slideNodes);
    }
  );
